import { UserProfile } from '../types';

class NotificationService {
  private permission: NotificationPermission = 'default';
  private listener: ((title: string, body: string, type: 'success' | 'info' | 'error') => void) | null = null;

  constructor() {
    if (typeof window !== 'undefined' && 'Notification' in window) {
      this.permission = Notification.permission;
    }
  }

  setListener(callback: (title: string, body: string, type: 'success' | 'info' | 'error') => void) {
    this.listener = callback;
  }

  async requestPermission(): Promise<boolean> {
    if (!('Notification' in window)) return false;
    
    const permission = await Notification.requestPermission();
    this.permission = permission;
    return permission === 'granted';
  }

  get hasPermission(): boolean {
    return this.permission === 'granted';
  }

  show(title: string, body: string, icon?: string, type: 'success' | 'info' | 'error' = 'info') {
    // Show in-app notification if listener exists
    if (this.listener) {
      this.listener(title, body, type);
    }

    if (this.permission !== 'granted') return;

    try {
      new Notification(title, {
        body,
        icon: icon || '/favicon.ico',
      });
    } catch (e) {
      console.error('Error showing notification:', e);
    }
  }

  notifyStatusUpdate(booking: any, oldStatus: string, user: UserProfile) {
    if (!user || !user.notificationSettings?.statusUpdate) return;
    
    let message = `Pesanan Anda kini berstatus: ${booking.status}`;
    let type: 'success' | 'info' | 'error' = 'info';
    
    if (oldStatus === 'Menunggu' && booking.status === 'Proses') {
      message = `Kapster mulai mengerjakan pesanan Anda! (${booking.serviceName || 'Layanan'})`;
      type = 'success';
    } else if (oldStatus === 'Proses' && booking.status === 'Selesai') {
      message = `Pesanan Anda telah selesai. Terima kasih telah menggunakan CukurJe!`;
      type = 'success';
    }

    this.show('Update Pesanan', message, undefined, type);
  }

  notifyNewBooking(booking: any, user: UserProfile) {
    if (!user || !user.notificationSettings?.newBooking) return;
    this.show('Pesanan Baru', `Ada pesanan baru masuk untuk layanan: ${booking.serviceName || 'Layanan'}`, undefined, 'success');
  }

  notifyNewChat(message: any, user: UserProfile) {
    if (!user || !user.notificationSettings?.newChat) return;
    this.show('Pesan Baru', `${message.senderName}: ${message.text.substring(0, 50)}${message.text.length > 50 ? '...' : ''}`, undefined, 'info');
  }
}

export const notificationService = new NotificationService();
